import { SECTION } from "./config";

/**
 * Section metadata — controls labels, display order, and collapsibility.
 * Ordered by how they appear in the UI (top to bottom).
 */
export const SECTION_META = {
  [SECTION.SHOP_DASHBOARD]: {
    label: null,
    order: 0,
    collapsible: false,
  },
  [SECTION.USER_ACCOUNT]: {
    label: "My Account",
    order: 1,
    collapsible: false,
  },
  [SECTION.ADMIN_ORDERS]: {
    label: "Orders & Fulfillment",
    order: 2,
    collapsible: false,
  },
  [SECTION.ADMIN_CONTENT]: {
    label: "Content & Products",
    order: 3,
    collapsible: false,
  },
  [SECTION.ADMIN_USERS]: {
    label: "Users & Accounts",
    order: 4,
    collapsible: false,
  },
  [SECTION.ADMIN_MARKETING]: {
    label: "Marketing & Events",
    order: 5,
    collapsible: false,
  },
  [SECTION.ADMIN_SYSTEM]: {
    label: "System & Config",
    order: 6,
    collapsible: false,
  },
  [SECTION.UTILITY]: {
    label: null,
    order: 99,
    collapsible: false,
  },
};
